import { Navigate } from 'react-router-dom'
import { useModuleEnabled } from 'hooks/useModuleEnabled'
import { useUser } from 'contexts/UserContext'

interface ModuleRouteProps {
  module: string
  children: React.ReactNode
}

/**
 * Componente guard per route protette da feature flag.
 * Se il modulo non è abilitato per il tenant, reindirizza alla dashboard.
 *
 * @example
 * <Route
 *   path="/leads"
 *   element={
 *     <ModuleRoute module="leads">
 *       <LeadsPage />
 *     </ModuleRoute>
 *   }
 * />
 */
export function ModuleRoute({ module, children }: ModuleRouteProps) {
  const isEnabled = useModuleEnabled(module)
  const { user, loading } = useUser()

  if (loading) return <p role="status">Caricamento accesso…</p>
  if (!user) return <Navigate to="/login" replace />

  if (!isEnabled) {
    return <Navigate to="/dashboard-new" replace />
  }

  return <>{children}</>
}
